import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cv-empty-objectives-tab',
  template: ''
})
export class EmptyObjectivesTabComponent implements OnInit {
  @Input() groupLevel: number;
  @Output() tabSelected = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    this.tabSelected.emit(this.groupLevel);
  }

}
